<template>
  <div class="component-signup">
    <div class="signup-box" v-if="isforgetPassword">
      <div class="signup-form">
        <h1 class="login-title">{{ $t('new.t1') }}</h1>
        <div>
          <el-form :model="form" :rules="rules" ref="form" status-icon label="top">
            <el-form-item prop="email" :label="$t('new.t2')">
              <el-input :placeholder="$t('Login.email')" v-model="form.email"></el-input>
            </el-form-item>
            <el-form-item class="mb10">
              <el-button type="button" class="btn-confirm-signup" @click="forgetpassword('form')">{{ $t('new.t3') }}</el-button>
            </el-form-item>
          </el-form>          
        </div>
      </div>
    </div>

    <div class="signup-box" v-if="isresetPassword">
      <div class="signup-form">
        <h1 class="login-title">重置密码</h1>
        <div>
          <p>注册邮箱：{{ resetPassWordEmail }}</p>
          <el-form :model="passwdform" :rules="rules" ref="passwdform" status-icon label="top">
            <el-form-item prop="passwd">
              <el-input placeholder="密码" v-model="passwdform.passwd" type="password" show-password></el-input>
            </el-form-item>
            <el-form-item prop="chkpasswd">
              <el-input placeholder="确认密码" v-model="passwdform.chkpasswd" type="password" show-password></el-input>
            </el-form-item>
            <el-form-item class="mb10">
              <el-button type="button" class="btn-confirm-signup" @click="resetpassword('passwdform')">确认修改</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>  

    <el-dialog :title="$t('new.t5')" :visible.sync="dialogSuccessVisible" width="50%">
      <span>{{ $t('new.t6') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSuccessVisible = false">{{ $t('dsfx.t33') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog title="该电子邮件地址不存在" :visible.sync="dialogErrorVisible" width="50%">
      <span>抱歉，此电子邮件地址不存在，请检查后重新填写</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogErrorVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="密码修改成功" :visible.sync="resetpasswordsuccess" width="50%">
      <span>您的密码已经修改成功，请重新登录</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goToLoginPage">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="密码修改成功" :visible.sync="resetpassworderror" width="50%">
      <span>链接已过期，请重新发送邮件</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="reloadPage">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.passwdform.chkpasswd !== '') {
            this.$refs.passwdform.validateField('chkpasswd');
          }
          callback();
        }
      };
      var validatePassType = (rule, value, callback) => {
        var rexxx = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{5,20}$/;
        if(value !== ''){
          if(rexxx.test(this.passwdform.passwd)){
            this.$refs.passwdform.validateField('chkpasswd');
          }else{
            callback(new Error('只包含字母、数字和符号，至少包含以下两种：字母、数字、符号'));
          }
        }
        callback();
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.passwdform.passwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        form:{
          email : '',
          passwd : '',
          chkpasswd : '',
        },
        passwdform:{
          email : '',
          passwd : '',
          chkpasswd : '',
        },
        rules: {
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
          ],
          email: [
            { required: true, message: this.$t('new.t4'), trigger: 'blur' },
            { type: 'email', message: '必须包含@符号。@前长度50，@字符后长度50。', trigger: ['blur', 'change'] }
          ],
          company: [
            { required: true, message: '请输入公司名称', trigger: 'blur' },
          ],
          passwd: [
            {min:5, max: 25, message: '包含5-25个字符', trigger: 'blur' },
            {validator: validatePass, trigger: 'blur'},
            {validator: validatePassType, trigger: 'blur'}
          ],
          chkpasswd: [
            {validator: validatePass2, trigger: 'blur'}
          ],
          phonenum: [],
          verifycode: []
        },
        dialogSuccessVisible: false,
        dialogErrorVisible: false,
        isforgetPassword: true,
        isresetPassword: false,
        resetPassWordEmail: '',
        uuid: '',
        resetpasswordsuccess: false,
        resetpassworderror: false,
      }
    },
    mounted() {
      if (this.$route.query.passwordtoken) {
        console.log('this.$route.query.passwordtoken');
        var that = this;
        that.isforgetPassword = false;
        that.isresetPassword = true;
        that.resetPassWordEmail = this.$route.query.email;
        that.uuid = this.$route.query.uuid;
        // this.Verification.inputAdress.value = this.$route.query.email;
      }
    },
    methods : {

      goToLoginPage: function(){
        this.resetpasswordsuccess = false
        this.$router.push({ path: "/Login" });
      },

      forgetpassword(formName) {
        let _this = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //var that = this;
            let dataforgetpassword = {
              email: this.form.email
            };
            $.ajax(
              this.API_URL + '/v3/verify/email',
              {
                type: "GET",
                data: dataforgetpassword,
                contentType: "application/json",
                success: function(data) {
                  console.log(data);
                  _this.dialogSuccessVisible = true;
                },
                error: function(response) {
                  console.log('Error-----',response);
                  _this.dialogErrorVisible = true;
                }
              }
            );
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },

      //新密码
      resetpassword(formName) {
        //let _this = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var that = this;
            //需要token*
            let dataNewpassword = {
              passwordtoken: this.$route.query.passwordtoken,
              uuid: that.uuid,
              password: that.passwdform.passwd
            };
            //新密码接口
            $.ajax(
              that.API_URL + '/v3/verify/email',
              {
                type: "PUT",
                data: JSON.stringify(dataNewpassword),
                contentType: "application/json",
                success: function(data) {
                  console.log(data)
                  that.resetpasswordsuccess = true;
                },
                error: function(response) {
                  console.log('resetpassworderror',response);
                  if(response.status == 400){
                    console.log('400')
                    that.resetpassworderror = true
                  }
                }
              }
            )
          }else{
            console.log('-----Error resetpassword');
          }

        })
      },

      reloadPage(){
        this.resetpassworderror = false;
        this.isforgetPassword = true;
        this.isresetPassword = false;
        this.$router.push({ path: "/LostPassword" });
      },

    }
}
</script>

<style>
.component-signup{
  min-height: 800px;
  padding-top: 100px;
  padding-bottom: 50px;
  height: calc(100vh - 80px);
  background-image: url(../assets/img/login-bg.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;  
}
.component-signup:before,
.component-signup:after{
  content: '';
  display: table;
}
.component-signup:after{
  clear: both;
}
.signup-box{
  width: calc(100% - 300px);
  min-width: 400px;
  padding-top: 50px;
  padding-bottom: 50px;
  margin: auto;
  background-color: #fff;
}
.signup-form{
  width: 350px;
  margin: auto;
}
.login-title {
  font-size: 24px;
  color: #000000;
  line-height: 29px;
  font-weight: 600;
  margin-bottom: 30px;
  font-weight: normal;
}
.btn-get-verifycode{
  width: 100%;
}
.btn-confirm-signup{
  width: 100%;
  background: #7290f2;
  border-radius: 2px;
  font-size: 14px;
  color: #ffffff;
}
.p-has-account{
  margin: 0;
  padding: 0;
}
.el-form-item.mb10{
  margin-bottom: 10px;
}
.a-to-login{
  color:#007bff;
  text-decoration: none;
}
.input-with-prefix .el-input-group__prepend{
  padding: 0 10px;
}
</style>